import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1 12C1 5.92902 5.91641 1 11.99 1C18.0716 1 23 5.92706 23 12C23 18.0729 18.0716 23 11.99 23C5.91641 23 1 18.071 1 12ZM11.99 3C7.02359 3 3 7.03098 3 12C3 16.969 7.02359 21 11.99 21C16.9684 21 21 16.9671 21 12C21 7.03294 16.9684 3 11.99 3ZM12.0007 7.56733L10.766 10.485L7.59648 10.7561L9.99052 12.8287L9.27105 15.9267L12 14.2825L14.7182 15.9202L13.9998 12.8185L16.3944 10.7454L13.2347 10.475L12.0007 7.56733ZM15.7361 16.5334L15.4781 16.9616L15.22 17.39L15.7378 16.5345C15.7372 16.5341 15.7366 16.5338 15.7361 16.5334ZM14.7037 18.2464C14.7032 18.2461 14.7027 18.2458 14.7022 18.2455L12 16.6175L9.2978 18.2455C9.29742 18.2457 9.29704 18.246 9.29666 18.2462C8.16766 18.9283 6.75384 17.9238 7.05592 16.6238C7.05595 16.6237 7.0559 16.6239 7.05592 16.6238L7.76948 13.5513L5.38987 11.4912C4.39404 10.6161 4.94281 8.98289 6.24946 8.86411L6.25475 8.86363L9.39404 8.59504L10.618 5.7028C11.1307 4.47591 12.8688 4.47573 13.3818 5.70227L14.6053 8.58498L17.7505 8.85409C19.059 8.97304 19.6104 10.6149 18.5924 11.4879C18.5912 11.4889 18.5901 11.4899 18.5889 11.4908L16.2202 13.5415L16.934 16.6235C17.2294 17.8968 15.8555 18.9419 14.7037 18.2464Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13.87 8C13.87 11.2419 11.2419 13.87 8 13.87C4.75809 13.87 2.13 11.2419 2.13 8C2.13 4.75809 4.75809 2.13 8 2.13C11.2419 2.13 13.87 4.75809 13.87 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.54395 6.24961L8.80901 6.88688L9.497 6.94204L10.9082 7.05517L9.83301 7.97616L9.30883 8.42517L9.46898 9.09654L9.79745 10.4736L8.5893 9.73566L8.00028 9.37589L7.41127 9.73566L6.20312 10.4736L6.53159 9.09654L6.69174 8.42517L6.16756 7.97616L5.0924 7.05517L6.50357 6.94204L7.19156 6.88688L7.45662 6.24961L8.00028 4.94247L8.54395 6.24961ZM4.0914 6.0018L6.41326 5.81565L7.30779 3.66495C7.56399 3.04898 8.43658 3.04898 8.69277 3.66495L9.5873 5.81565L11.9092 6.0018C12.5742 6.05511 12.8438 6.88499 12.3372 7.31899L10.5681 8.83435L11.1086 11.1001C11.2634 11.749 10.5575 12.2619 9.98813 11.9142L8.00028 10.7L6.01244 11.9142C5.44311 12.2619 4.73718 11.749 4.89197 11.1001L5.43243 8.83435L3.66341 7.31899C3.15676 6.88499 3.4264 6.05511 4.0914 6.0018Z"
  />
);

export const StarIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Star" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
